"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerCatchAll = exports.sendError = void 0;
var apiUrls_1 = __importDefault(require("./apiUrls"));
var Cookie_1 = __importStar(require("./Cookie"));
var logToConsole = function (message) {
    /* eslint-disable no-console */
    if (console && console.warn) {
        console.warn(message);
    }
    /* eslint-enable no-console */
};
var sendError = function (error) {
    var _a;
    if (window === null || window === void 0 ? void 0 : window.XMLHttpRequest) {
        var apiBaseUrl = (_a = document.getElementById('react-app')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-api-url');
        try {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', "".concat(apiBaseUrl, "/").concat(apiUrls_1.default.admin.log, "/error"));
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('X-CSRF-TOKEN', Cookie_1.default.getValue(Cookie_1.CookieNames.csrf));
            xhr.send(JSON.stringify(error));
        }
        catch (_b) {
            logToConsole('An error occured. Logging to server failed..');
        }
    }
    else {
        logToConsole('An error occured. Logging to server unavailable..');
    }
};
exports.sendError = sendError;
var registerCatchAll = function () {
    window.onerror = function (msg, url, line, col, error) {
        if (msg.toString().toLowerCase().indexOf('script error') > -1) {
            // console.log('script error..', [msg, url, line, col, error]);
            // no details available for script errors
        }
        else {
            // i.e. network errors
            (0, exports.sendError)({
                sender: 'CatchAll',
                error: msg.toString(),
                info: "Url: ".concat(url, ", Line: ").concat(line, ", Col: ").concat(col, ", Error: ").concat(error),
            });
        }
        return false;
    };
};
exports.registerCatchAll = registerCatchAll;
